import { IObservableArray, makeAutoObservable, observable } from "mobx";
import NewsServerClient from "../ServerClients/NewsServerClient";
import { EmptyLittleNewsImpl, LittleNewsApi } from "../DTO/View/LittleNewsDTO";
import { NewsItemResponseApi } from "../DTO/ServerResponseType/News/NewsItem";

export default class NewsStore {
  public news: IObservableArray<NewsItemResponseApi> = observable.array([]);
  public showDeleteModal: boolean = false;
  public deleteNewsData: LittleNewsApi = new EmptyLittleNewsImpl();

  constructor() {
    makeAutoObservable(this);
  }

  public onDeleteModalOpen = (newsData: LittleNewsApi) => {
    this.showDeleteModal = true;
    this.deleteNewsData = newsData;
  };

  public onDeleteModalClose = () => {
    this.showDeleteModal = false;
  };

  public setNews = (news: NewsItemResponseApi[]) => {
    this.news.replace(news);
  };

  public deleteNewsItem = (newsItemId: string) => {
    NewsServerClient.sendToDeleteNewsAsync(newsItemId).then(() => {
      this.news.replace(this.news.filter((a: any) => a.newsId !== newsItemId));
    });
  };

  public loadAllNewsAsync = async (): Promise<
    NewsItemResponseApi[] | never
  > => {
    return NewsServerClient.sendToGetAllNewsAsync().then((news) => {
      this.setNews(news);
      return news;
    });
  };

  public loadOtherNewsAsync = async (
    newsId: string
  ): Promise<NewsItemResponseApi[] | never> => {
    const numOtherNews = 3;

    return NewsServerClient.sendToGetAnyNewsAsync(numOtherNews + 1).then(
      (news) => {
        let otherNews: NewsItemResponseApi[] = news;
        return otherNews
          .filter((newsItem) => newsItem.newsId !== newsId)
          .splice(0, 3);
      }
    );
  };
}
